module.exports = __webpack_public_path__ + "img/zs_14@2x.50527863.png";